export type ListTileProps = {
  id: string;
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
  labels?: Array<TileLabel>;
  isSelectable?: boolean;
  labelsGap?: string;
  onPress?: (id: string) => void;
  isActive?: boolean;
  isLoading?: boolean;
};

export class TileLabel {
  key?: string;
  text?: string;
  fontFamily?: "roboto" | "inter";
  fontSize?:
    | "xs"
    | "sm"
    | "md"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "2xs"
    | "4xl"
    | "5xl"
    | "6xl";
  fontColor?: string;
  fontWeight?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;

  constructor(props: TileLabel) {
    Object.assign(this, props);
  }
}
